import moment from 'moment';
import DatePicker from "vue2-datepicker";
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import { datePickerLang } from "@/constants/globalConstants";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StaffFixAlwValidationObj from "./StaffFixAlwValidation.js";
import Settings from '../../../../constants/Settings.js';
import { StaffFixAlw } from "@/model/StaffFixAlw";
import StaffFixAlwService from "@/service/StaffFixAlwService";
import PayrollAdjustmentService from "@/service/PayrollAdjustmentService";
import ArrayHelper from "@/common/helper/ArrayHelper";
var staffFixAlwValidationObj = new StaffFixAlwValidationObj();
export default {
    name: "staffFixAlwView",
    components: {
        DatePicker
    },
    props: [
        "staffModel", "isViewMode"
    ],
    data: () => ({
        t: t,
        dictEnum: dictEnum,
        Settings: Settings,
        lang: datePickerLang,
        fields: [
            {
                key: "DateEff",
                label: t.t(dictEnum.LBL_Date),
                width: "24%",
                align: "center",
            },
            {
                key: "IncTypeDesc",
                label: t.t(dictEnum.LBL_IncType),
                width: "24%",
                align: "left"
            },
            {
                key: "IncSubType",
                label: t.t(dictEnum.LBL_IncSubType),
                width: "24%",
                align: "left"
            },
            {
                key: "Amt",
                label: t.t(dictEnum.LBL_Amount),
                width: "24%",
                align: "right"
            }
        ],
        tableData: [],
        incTypeList: [],
        staffList: [],
        staffFixAlw: new StaffFixAlw(),
    }),
    computed: {
        user() {
            return this.$store.getters[StoreGetter.user];
        },
        disabledMode() {
            return this.isViewMode
        },
        IncTypes() {
            const list = this.incTypeList;
            const Datas = ArrayHelper.uniqueBykey(list, "IncTypeDesc");
            return Datas;
        },
        StaffFixAlwList() {
            const list = this.staffModel.StaffFixAlwList;
            list.forEach((x) => x.DateEff = moment(x.DateEff).format(Settings.DateTime.yyyymmdd))
            ArrayHelper.sortByKey(list, 'DateTx');
            return list;
        }
    },
    mounted() {
        staffFixAlwValidationObj.StaffFixAlwValidation();
        this.getIncTypeList();
    },
    methods: {

        formatAmt(e) {
            return String(e).substring(0, 10);
        },

        async initStaffFixAlw() {
            const valid = await this.$validator.validateAll();
            if (!valid) return;
            const data = new StaffFixAlw();
            data.StaffID = this.staffModel.StaffID;
            this.staffModel.StaffFixAlwList.push(data);
            this.onlyEditMode(data)
        },
        
        async onEditStaffFixAlw(selected) {
            const valid = await this.$validator.validateAll();
            if (!valid || this.disabledMode) return;
            selected.DateEff = moment(selected.DateEff).format(Settings.DateTime.yyyymmdd);
            this.onlyEditMode(selected)
        },

        changeDateEff(item) {
            item.DateEff = moment(item.DateEff).format(Settings.DateTime.yyyymmdd);
            this.onlyEditMode(item)
        },

        async onlyEditMode(data) {
            const find = this.staffModel.StaffFixAlwList.filter((x) => x.DateEff == data.DateEff && x.IncTypeDesc == data.IncTypeDesc && x.IncSubType == data.IncSubType);
            if (find.length > 1) {
                data.IncSubType = ''
                SweetAlertService.warning("Warn", t.t(dictEnum.MSG_AlreadyExists));
                return;
            }
            this.staffModel.StaffFixAlwList.forEach((x) => {
                if (x.DateEff == data.DateEff && x.IncTypeDesc == data.IncTypeDesc && x.IncSubType == data.IncSubType) {
                    this.staffFixAlw = data;
                    x.EditMode = true;
                } else {
                    x.EditMode = false;
                }
            })
        },

        async deleteStaffFixAlw(selectedIndex) {
            if (this.disabledMode) return;
            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: `${t.t(dictEnum.WARN_Delete)}`,
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) {
                this.staffModel.StaffFixAlwList = this.staffModel.StaffFixAlwList.filter((x, i) => i != selectedIndex)
            }
        },

        changeIncType(item) {
            item.IncSubType = "";
        },

        async getIncTypeList() {
            const obj = {};
            const response = await PayrollAdjustmentService.getIncTypeList(obj);
            if (response.data.IsSuccess) {
                this.incTypeList = response.data.Data.filter(x => x.MPF);
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/StaffFixAlw/StaffFixAlwView.js